import breaks from "@bytemd/plugin-breaks";
import frontmatter from "@bytemd/plugin-frontmatter";
import gemoji from "@bytemd/plugin-gemoji";
import gfm from "@bytemd/plugin-gfm";
import highlight from "@bytemd/plugin-highlight";
import math from "@bytemd/plugin-math";
import mediumZoom from "@bytemd/plugin-medium-zoom";
import mermaid from "@bytemd/plugin-mermaid";
import {Viewer} from "@bytemd/react";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import {generateClient} from "aws-amplify/api";
import {fetchAuthSession} from "aws-amplify/auth";
import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {getBlogPost} from "../graphql/queries";
import "bytemd/dist/index.css";

const plugins = [
    breaks(),
    frontmatter(),
    gemoji(),
    gfm(),
    highlight(),
    math(),
    mediumZoom(),
    mermaid()
];

function BlogPost() {
    const navigate = useNavigate();
    const {id} = useParams();
    const [blogPost, setBlogPost] = useState({});
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        async function currentSession() {
            const {accessToken} = (await fetchAuthSession()).tokens ?? {};
            setIsAdmin(accessToken?.payload["cognito:groups"].includes("cfsAdmin"));
        }
        async function fetchData() {
            if (!id) {
                navigate("/projects");
                return;
            }
            const client = generateClient();
            const blogPost = await client.graphql({
                query: getBlogPost,
                variables: {id: id},
                authMode: "iam"
            });
            setBlogPost(blogPost.data.getBlogPost);
        }

        void currentSession();
        void fetchData();
    }, [navigate, id]);

    return (
        <section id="about" className="content-section">
            <div className="content entire-paragraph">
                {isAdmin &&
                    <div style={{textAlign: "right", marginBottom: 16}}>
                        <Button size="small" startIcon={<EditIcon/>} onClick={() => navigate("/blog_form/" + id)}>
                            Edit Post
                        </Button>
                    </div>
                }
                <Viewer plugins={plugins} value={blogPost?.long_description}/>
            </div>
        </section>
    );
}

export default BlogPost;
